<template>
    <div class="container-fluid">
        <div class="row">
            <TableListPreparation/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
const TableListPreparation = defineAsyncComponent(() => import("@/components/theme/receipt-product/TableListPreparation.vue"))
</script>